import RequestTypeRecord from 'automation-ui-canvas/actions/utils/RequestTypeRecord';
import { registerRequestTypes } from 'automation-ui-canvas/actions/utils/actionsToArtifacts';
export default function createRequestTypes(baseActionType, {
  once = false
} = {}) {
  const requestTypes = new RequestTypeRecord({
    key: baseActionType,
    once,
    REQUESTED: `${baseActionType}_REQUESTED`,
    SUCCEEDED: `${baseActionType}_SUCCEEDED`,
    FAILED: `${baseActionType}_FAILED`
  });
  registerRequestTypes(requestTypes);
  return requestTypes;
}